import { combineReducers } from "redux"

import userData from "./reducrs/user"
import CarsData from "./reducrs/car"
import ProductsData from "./reducrs/product"
import CartData from "./reducrs/cart"

const allReducers = combineReducers({
    userData,
    CarsData,
    ProductsData,
    CartData
})

export default allReducers